import session from './session'
import {ENDPOINT} from './index'

export default {
  filter (data) {
    return session.post(ENDPOINT + '/notification/filter_notification/', data)
  },
  updateUnread (data) {
    return session.post(ENDPOINT + '/notification/update_unread_notification/', data)
  },
  markAllAsRead () {
    return session.post(ENDPOINT + '/notification/mark_all_as_read/', {})
  }
}



// WEBPACK FOOTER //
// ./src/api/notification.js